<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <Filter></Filter>
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import Filter from './components/Filter.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
import dayjs from 'dayjs'
import {
  queryPageTaskInfo,
  addTaskInfo,
  updateTaskInfo,
  deleteTaskInfo,
  getAllTaskCategory,
  updateTaskInfoByStatus,
  detailTaskInfo
} from 'server/modules/task'
import { common_lang_get } from 'server/modules/3426'
import useAPI from 'UseApi'
const { common_querySiteInfo_get_ } = useAPI(null, [3426])
import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    List,
    Filter,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {
        // terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [
        // {
        //   taskId: 1,
        //   assortName: 11,
        //   typeName: 22,
        //   taskCategory: 1,
        //   // typeId: 2,
        //   day: 12,
        //   number: 13,
        //   rewardType: 3,
        //   targetType: 1,
        //   taskName: JSON.stringify([{ key: 11, value: 22 }]),
        //   taskDesc: JSON.stringify([{ key: 11, value: 22 }]),
        //   taskRetention: JSON.stringify([{}]),
        //   taskRewardName: JSON.stringify([{ key: 11, value: 22 }]),
        //   taskRewardDesc: JSON.stringify([{ key: 11, value: 22 }]),
        //   taskTargetName: JSON.stringify([{ key: 11, value: 22 }]),
        //   taskTargetDesc: JSON.stringify([{ key: 11, value: 22 }])
        // }
      ],
      bodyStyle: {
        height: '750px',
        overflow: 'hidden',
        overflowY: 'scroll'
      },
      unitOps: {
        1: '积分',
        2: '抽奖次数',
        3: '优惠券'
      },
      taskTerminalOps: {
        1: 'web',
        2: 'app',
        0: 'all'
      },
      typeOps: {
        1: '签到',
        2: '浏览',
        3: '分享'
      },
      targetActionOps: {
        1: '点击',
        2: '浏览',
        3: '抽奖助力',
        4: '访问页面'
      },
      finishTypeOps: {
        0: '一次性任务',
        1: '每日任务'
      },
      //分类数据
      assortSelect: [
        // {
        //   id: 1,
        //   name: 22
        // },
        // {
        //   id: 2,
        //   name: 33
        // }
      ],
      brands: [],
      channels: [],
      sites: [],
      //语言数据
      langList: [
        // {
        //   key: '11',
        //   value: '22'
        // },
        // {
        //   key: '22',
        //   value: '33'
        // },
        // {
        //   key: '44',
        //   value: '55'
        // }
      ],
      selectLangList: [],
      //列
      columns: [
        {
          title: '任务ID',
          align: 'center',
          dataIndex: 'taskId',
          key: 'taskId'
        },
        {
          title: '任务分类',
          align: 'center',
          dataIndex: 'taskCategoryName',
          key: 'taskCategoryName'
        },
        // {
        //   title: '任务ID',
        //   align: 'center',
        //   dataIndex: 'taskId',
        //   key: 'taskId'
        // },
        {
          title: '目标类型',
          align: 'center',
          dataIndex: 'targetType',
          key: 'targetType'
        },
        // {
        //   title: '任务限制',
        //   align: 'center',
        //   dataIndex: 'limitation',
        //   key: 'limitation'
        // },
        {
          title: '任务有效期',
          dataIndex: 'startTime',
          key: 'startTime',
          align: 'center'
        },
        // {
        //   title: '创建人',
        //   dataIndex: 'createUser',
        //   key: 'createUser',
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center'
        },
        {
          title: '任务状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      transformNum: value => {
        let v = null
        switch (typeof value) {
          case 'string':
            v = isNaN(+value) ? 1 : value.replace(/\./g, '')
            break
          case 'number':
            v = isNaN(value) ? 1 : String(value).replace(/\./g, '')
            break
          default:
            v = 1
        }
        return v
      },
      changeDate() {
        console.log(state.form.limitTime)
      },
      //筛选
      filterData: {
        taskId: '',
        targetType: undefined,
        status: undefined
      },
      //重置筛选
      resetFilter: () => {
        state.filterData = {
          taskId: '',
          targetType: undefined,
          status: undefined
        }
        state.initList()
      },
      //0新增 1编辑 2详情
      modalType: 0,
      initList: () => {
        state.getTabList()
        state.getAssortList()
        state.initCommonLang()
      },
      //table数据
      getTabList: () => {
        const param = {
          ...state.searchParams,
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize,
          taskId: state.filterData.taskId,
          targetType: state.filterData.targetType,
          status: state.filterData.status
        }
        // alert(JSON.stringify(param))
        queryPageTaskInfo(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      getAssortList() {
        getAllTaskCategory()
          .then(e => {
            if (e.success) {
              state.assortSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      initCommonLang: async () => {
        const { data } = await common_lang_get(state.searchParams)
        state.langList = Object.entries(data.languageMap).map(
          ([key, value]) => ({
            label: key,
            value
          })
        )
      },
      modalVisible: false,
      formRef: null,
      form: {
        taskName: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskDesc: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskRetention: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskRewardName: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskRewardDesc: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskTargetName: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskTargetDesc: [
          {
            key: undefined,
            value: undefined
          }
        ]
      },
      //校验
      rules: {
        taskTerminal: [{ required: true, message: '请选择终端！' }],
        // taskRetention: [{ required: true, message: '请输入使用门槛！' }],
        taskCategory: [{ required: true, message: '请选择分类！' }],
        // typeId: [{ required: true, message: '请选择类型！' }],
        activityId: [{ required: true, message: '请输入活动ID！' }],
        rewardType: [{ required: true, message: '请选择达成奖励！' }],
        emptyTime: [{ required: true, message: '请选择任务有效期！' }],
        rewardValue: [{ required: true, message: '请输入奖励值！' }],
        rewardCount: [{ required: true, message: '请输入奖励数量！' }],
        finishCountLimit: [{ required: true, message: '请输入可完成次数！' }],
        targetType: [{ required: true, message: '请选择可目标类型！' }],
        targetAction: [{ required: true, message: '请选择目标行为！' }],
        targetValue: [{ required: true, message: '请输入行为次数！' }],
        finishType: [{ required: true, message: '请选择任务完成类型！' }],
        finishEmptyTime: [{ required: true, message: '请选择完成时间！' }],
        targetUrl: [{ required: true, message: '请填写web任务路径！' }],
        targetPage: [{ required: true, message: '请填写web任务页面！' }],
        targetAppUrl: [{ required: true, message: '请填写app任务路径！' }],
        targetAppPage: [{ required: true, message: '请填写app任务页面！' }],
        taskActivityId: [{ required: true, message: '请填写web活动ID！' }],
        taskAppActivityId: [{ required: true, message: '请填写app活动ID！' }]
      },
      add: type => {
        state.modalType = type
        state.form.taskTerminal = 1
        state.form.rewardCount = 0
        state.form.finishCountLimit = 1
        state.form.finishType = 0
        state.form.rewardType = '1'
        // state.form.completionNumber = 1
        state.form.targetType = undefined
        state.form.targetAction = undefined
        state.form.targetValue = 0
        // state.form.limitTimeUnit = 2
        state.modalVisible = true
      },
      changeRangePicker() {
        state.form.startTime =
          state.form.emptyTime !== null
            ? dayjs(state.form.emptyTime[0]).format('YYYY-MM-DD HH:mm:ss')
            : ''
        state.form.endTime =
          state.form.emptyTime !== null
            ? dayjs(state.form.emptyTime[1]).format('YYYY-MM-DD HH:mm:ss')
            : ''
      },
      changeFinishRangePicker() {
        state.form.finishStartTime =
          state.form.finishEmptyTime !== null
            ? dayjs(state.form.finishEmptyTime[0]).format('YYYY-MM-DD')
            : ''
        state.form.finishEndTime =
          state.form.finishEmptyTime !== null
            ? dayjs(state.form.finishEmptyTime[1]).format('YYYY-MM-DD')
            : ''
      },
      selectType() {
        if (state.form.rewardType === '1') {
          state.form.rewardValue = ''
        } else if (state.form.rewardType === '2') {
          state.form.rewardValue = ''
        } else if (state.form.rewardType === '3') {
          state.form.rewardValue = ''
        }
      },
      selectFinishType() {
        if (state.form.finishType === 0) {
          state.form.finishCountLimit = ''
        } else {
          state.form.finishEmptyTime = []
        }
      },
      changeType() {
        // if (state.form.typeId === 1) {
        //   state.form.eventTypeId = ''
        //   state.form.completionNumber = 1
        //   state.form.limitTime = ''
        //   state.form.limitTimeUnit = 2
        //   state.form.activityId = ''
        // } else {
        //   state.form.url = ''
        //   state.form.page = ''
        //   state.form.duration = ''
        //   state.form.activityId = ''
        // }
      },
      changeBrowse() {
        // state.form.targetUrl = ''
        // state.form.targetPage = ''
        // state.form.targetAppUrl = ''
        // state.form.targetAppPage = ''
      },
      changeBrowseTwo() {
        state.form.targetUrl = ''
        state.form.targetPage = ''
        state.form.targetAppUrl = ''
        state.form.targetAppPage = ''
      },
      changeTargetType() {
        state.form.targetAction = ''
      },
      changeTaskName() {
        let keys = []
        if (state.form.taskName.length > 0) {
          for (let i = 0; i < state.form.taskName.length; i++) {
            keys.push(state.form.taskName[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeTaskDesc() {
        let keys = []
        if (state.form.taskDesc.length > 0) {
          for (let i = 0; i < state.form.taskDesc.length; i++) {
            keys.push(state.form.taskDesc[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeTaskRetention() {
        let keys = []
        if (state.form.taskRetention.length > 0) {
          for (let i = 0; i < state.form.taskRetention.length; i++) {
            keys.push(state.form.taskRetention[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeTaskTargetName() {
        let keys = []
        if (state.form.taskTargetName.length > 0) {
          for (let i = 0; i < state.form.taskTargetName.length; i++) {
            keys.push(state.form.taskTargetName[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeTaskTargetDesc() {
        let keys = []
        if (state.form.taskTargetDesc.length > 0) {
          for (let i = 0; i < state.form.taskTargetDesc.length; i++) {
            keys.push(state.form.taskTargetDesc[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeTaskRewardName() {
        let keys = []
        if (state.form.taskRewardName.length > 0) {
          for (let i = 0; i < state.form.taskRewardName.length; i++) {
            keys.push(state.form.taskRewardName[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeTaskRewardDesc() {
        let keys = []
        if (state.form.taskRewardDesc.length > 0) {
          for (let i = 0; i < state.form.taskRewardDesc.length; i++) {
            keys.push(state.form.taskRewardDesc[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      addContent() {
        state.form.taskRetention.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskRetention)
      },
      removeContent: info => {
        if (state.form.taskRetention.length > 1) {
          const index = state.form.taskRetention.indexOf(info)
          if (index !== -1) {
            state.form.taskRetention.splice(index, 1)
          }
        }
      },
      addNameContent() {
        state.form.taskName.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskName)
      },
      removeNameContent: info => {
        if (state.form.taskName.length > 1) {
          const index = state.form.taskName.indexOf(info)
          if (index !== -1) {
            state.form.taskName.splice(index, 1)
          }
        }
      },
      addDescContent() {
        state.form.taskDesc.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskDesc)
      },
      removeDescContent: info => {
        if (state.form.taskDesc.length > 1) {
          const index = state.form.taskDesc.indexOf(info)
          if (index !== -1) {
            state.form.taskDesc.splice(index, 1)
          }
        }
      },
      addRewardNameContent() {
        state.form.taskRewardName.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskRewardName)
      },
      removeRewardNameContent: info => {
        if (state.form.taskRewardName.length > 1) {
          const index = state.form.taskRewardName.indexOf(info)
          if (index !== -1) {
            state.form.taskRewardName.splice(index, 1)
          }
        }
      },
      addRewardDescContent() {
        state.form.taskRewardDesc.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskRewardDesc)
      },
      removeRewardDescContent: info => {
        if (state.form.taskRewardDesc.length > 1) {
          const index = state.form.taskRewardDesc.indexOf(info)
          if (index !== -1) {
            state.form.taskRewardDesc.splice(index, 1)
          }
        }
      },
      addTargetNameContent() {
        state.form.taskTargetName.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskTargetName)
      },
      removeTargetNameContent: info => {
        if (state.form.taskTargetName.length > 1) {
          const index = state.form.taskTargetName.indexOf(info)
          if (index !== -1) {
            state.form.taskTargetName.splice(index, 1)
          }
        }
      },
      addTargetDescContent() {
        state.form.taskTargetDesc.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskTargetDesc)
      },
      removeTargetDescContent: info => {
        if (state.form.taskTargetDesc.length > 1) {
          const index = state.form.taskTargetDesc.indexOf(info)
          if (index !== -1) {
            state.form.taskTargetDesc.splice(index, 1)
          }
        }
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {
          taskName: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskDesc: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskRetention: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskRewardName: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskRewardDesc: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskTargetName: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskTargetDesc: [
            {
              key: undefined,
              value: undefined
            }
          ]
        }
        state.modalVisible = false
      },
      modalSubmit: async () => {
        if (state.modalType !== 2) {
          state.formRef
            .validateFields()
            .then(() => {
              const param = {
                ...state.form
              }
              // if (param.sendTimeType === '1') {
              //   param.sendTime = null
              // } else {
              //   param.sendTime = dayjs(param.sendTime).format(
              //     'YYYY-MM-DD HH:mm:ss'
              //   )
              // }
              if (param.taskTerminal === 1) {
                param.targetAppUrl = ''
                if (param.targetType !== '3') {
                  param.targetAppPage = ''
                }
                param.taskAppActivityId = ''
              } else if (param.taskTerminal === 2) {
                param.targetUrl = ''
                if (param.targetType !== '3') {
                  param.targetPage = ''
                }
                param.taskActivityId = ''
              }
              param.taskBrand = state.searchParams.brandId
              param.taskChannel = state.searchParams.channelId
              param.taskSite = state.searchParams.siteId
              // if (param.typeId === 1) {
              //   param.limitTimeUnit = ''
              //   param.completionNumber = ''
              // }
              param.taskName = JSON.stringify(param.taskName)
              param.taskDesc = JSON.stringify(param.taskDesc)
              param.taskRetention = JSON.stringify(param.taskRetention)
              param.taskRewardName = JSON.stringify(param.taskRewardName)
              param.taskRewardDesc = JSON.stringify(param.taskRewardDesc)
              param.taskTargetName = JSON.stringify(param.taskTargetName)
              param.taskTargetDesc = JSON.stringify(param.taskTargetDesc)
              if (param.finishType === 0) {
                param.finishStartTime = null
                param.finishEndTime = null
              }
              if (!param.taskId) {
                param.status = 1
              }
              // alert(JSON.stringify(param))
              // return false
              if (param.taskId) {
                updateTaskInfo(param)
                  .then(e => {
                    if (e.success) {
                      message.success('更新成功')
                      state.formRef.clearValidate()
                      state.form = {
                        taskName: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskDesc: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskRetention: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskRewardName: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskRewardDesc: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskTargetName: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskTargetDesc: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ]
                      }
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data)
                    }
                  })
                  .catch(err => {
                    console.log('err: ', err)
                    message.warning(err.retInfo)
                  })
              } else {
                addTaskInfo(param)
                  .then(e => {
                    if (e.success) {
                      if (e.data.succes) {
                        message.success('添加成功')
                        state.formRef.clearValidate()
                        state.form = {
                          taskName: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ],
                          taskDesc: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ],
                          taskRetention: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ],
                          taskRewardName: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ],
                          taskRewardDesc: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ],
                          taskTargetName: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ],
                          taskTargetDesc: [
                            {
                              key: undefined,
                              value: undefined
                            }
                          ]
                        }
                        state.modalVisible = false
                        state.initList()
                      } else {
                        message.warning(e.data.data)
                      }
                    } else {
                      message.warning(e.retInfo)
                    }
                  })
                  .catch(err => {
                    console.log('err: ', err)
                    message.warning(err.retInfo)
                  })
              }
            })
            .catch(e => {
              console.log('e: ', e)
            })
        } else {
          state.modalVisible = false
        }
      },
      handleOpen: info => {
        if (info) {
          const data = {
            taskId: info.taskId,
            status: info.status
          }
          updateTaskInfoByStatus(data)
            .then(e => {
              if (e.success) {
                message.success('设置成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      },
      handleEdit: (type, record) => {
        if (record) {
          const params = {
            taskId: record.taskId
          }
          detailTaskInfo(params)
            .then(e => {
              if (e.success) {
                // alert(JSON.stringify(e.data.data))
                let info = e.data.data
                state.form = {
                  ...info,
                  emptyTime: [dayjs(info.startTime), dayjs(info.endTime)],
                  // sendTime: info.immediately === 1 ? dayjs(info.sendTime) : '',
                  // sendTimeType: info.immediately === 0 ? '1' : '2',
                  taskName: JSON.parse(info.taskName),
                  taskDesc: JSON.parse(info.taskDesc),
                  taskRetention: JSON.parse(info.taskRetention),
                  taskRewardName: JSON.parse(info.taskRewardName),
                  taskRewardDesc: JSON.parse(info.taskRewardDesc),
                  taskTargetName: JSON.parse(info.taskTargetName),
                  taskTargetDesc: JSON.parse(info.taskTargetDesc),
                  finishEmptyTime: [
                    dayjs(info.finishStartTime),
                    dayjs(info.finishEndTime)
                  ]
                }
                state.modalVisible = true
                state.modalType = type
              }
            })
            .catch(err => {
              console.log('err: ', err)
            })
        }
      },
      handleDel: info => {
        if (info) {
          deleteTaskInfo(info)
            .then(e => {
              if (e.success) {
                message.success('删除成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
    })
    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
